import { useState, forwardRef } from 'react'
import type { ComponentProps } from 'react'

import Input from '@components/common/Input/Input'

import { PiEye, PiEyeSlash, PiLock } from 'react-icons/pi'

type PasswordInputProps = Omit<ComponentProps<typeof Input>, 'type' | 'prefix' | 'suffix'>

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <Input
      {...props}
      minLength={7}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      prefix={
        <PiLock className="absolute top-4 left-4 text-zinc-500 w-5 h-5 text-zinc-500" />
      }
      suffix={
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute top-4 right-4 text-zinc-500 hover:text-zinc-700 transition-colors"
        >
          {showPassword ? (
            <PiEyeSlash className="w-5 h-5 text-zinc-700" />
          ) : (
            <PiEye className="w-5 h-5 text-zinc-700" />
          )}
        </button>
      }
      className={`pl-12 pr-12 ${props['className']}`}
    />
  )
})

PasswordInput.displayName = 'PasswordInput'

export default PasswordInput